import React from 'react';

import styles from './OffersLayout2.module.scss';

import OfferTimer from "../../OfferTimer/OfferTimer";
import {FREE_TEXT, TAX_INCLUDED_TEXT} from "../../../../shared/constants";
import LoadableImage from "../../../LoadableImage/LoadableImage";

const OffersLayout2 = ({
    packId,
    image,
    priceFormatted,
    popUpImg,
    selectOfferById,
    openPopupInfo,
    endTime,
    categoryId,
    noTimers,
    isFree,
    isClaimed,
    isOnSale,
    noQuantityCap,
    leftPurchases
}) => {
    const id = packId;

    return (
        <div>
            {noTimers ?
                null
                :
                endTime ?
                    <OfferTimer endTime={endTime} isFree={isFree} />
                    :
                    <div className={styles.endsIn}></div>
            }
            {noQuantityCap ?
                null
                :
                <div className={`${styles.quantityCap} ${!noQuantityCap ? styles.hasQuatityCap : ''} ${noTimers ? styles.noTimers : ''}`}>
                    {leftPurchases ?
                        `残り回数：${leftPurchases}`
                        :
                        null
                    }
                </div>
            }
            <div className={`${styles.wrapper} ${isClaimed ? styles.claimed : null}`}>
                <LoadableImage img={image} />
                <div className={`${styles.offerLayoutPrice} ${isFree ? styles.free : ''} ${isOnSale ? styles.onSale : ''}`}>
                    <div className={styles.offerPrice}>{!isFree ? priceFormatted : FREE_TEXT}</div>
                    {!isFree ? <div className={styles.offerPriceText}>{TAX_INCLUDED_TEXT}</div> : null}
                </div>
                {popUpImg && openPopupInfo && !isClaimed ?
                    <div
                        className={styles.buttonInfo}
                        onClick={() => openPopupInfo({
                            img: popUpImg,
                            id: id,
                            categoryId: categoryId,
                            price: priceFormatted,
                            isFree: isFree,
                            isClaimed: isClaimed
                        })}
                    ></div>
                    :
                    null
                }
                <div
                    className={`${styles.buttonBuy} ${!popUpImg ? styles.normal : ''} ${isFree ? styles.free : ''}`}
                    onClick={() => {
                        if (!isClaimed) {
                            selectOfferById(id, categoryId);
                        }
                    }}
                >
                </div>
            </div>
        </div>
    );
};

export default OffersLayout2;